import { render, staticRenderFns } from "./OrderItemsTooltip.vue?vue&type=template&id=8bbec4e2"
import script from "./OrderItemsTooltip.vue?vue&type=script&lang=js"
export * from "./OrderItemsTooltip.vue?vue&type=script&lang=js"
import style0 from "./OrderItemsTooltip.vue?vue&type=style&index=0&id=8bbec4e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports